import {FC} from 'react'
import {InputText} from '../../InputV2'
import InputPassword2 from '../../InputV2/inputPassword2'
type Props = {
  name: string
  textPlaceholder?: string
  disabled?: boolean
  Uppercase?: boolean
  type?: string
  maxLength?: number
  required?: boolean
  labelText?: string
  readOnly?: boolean
}
const InputPasswordWrapper: FC<Props> = ({
  name,
  disabled,
  textPlaceholder,
  Uppercase,
  maxLength,
  required,
  labelText,
  type,
  readOnly,
}) => {
  let classLabel = required ? 'required' : ''
  return (
    <div>
      <label className={classLabel}>{labelText}:</label>
      <InputPassword2
        type={type}
        name={name}
        textPlaceholder={textPlaceholder}
        disabled={disabled}
        maxLength={maxLength}
        // Uppercase={Uppercase}
        // readOnly={readOnly}
      />
    </div>
  )
}

export default InputPasswordWrapper
